import React, { FC } from 'react'

import { PhysicalClientDetailsModal } from '../../ClientDetails/ClientPhysical'
import { ClientDetailsTriggerProps } from './ClientAccountChoosePanel.types'

const ClientDetailsTrigger: FC<ClientDetailsTriggerProps> = ({
  name,
  client,
  clientID,
  clientHash,
  IDScanCount,
  noTrigger,
  onClose,
}) => {
  return (
    //@ts-ignore
    <PhysicalClientDetailsModal
      name={name || 'ClientDetailsInOrderAdd'}
      disabled={!clientID && !client}
      defaultTabId="files"
      defaultTabIndex={15} // "files"
      ID={clientID || (client && client.ID)}
      hash={clientHash || (client && client.hash)}
      icon={IDScanCount || (client && client.IDScanCount) ? 'camera' : 'camera_no'}
      noTrigger={noTrigger}
      onClose={onClose}
    >
      {(clientID && IDScanCount) || (client && client.IDScanCount) || undefined}
    </PhysicalClientDetailsModal>
  )
}

export default ClientDetailsTrigger
